import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStore } from '../../stores/Store';
import { isMobile } from 'is-mobile';
import './style.scss';
import { View, TextInput, OutlinedButton, LoadingScreen } from '../../components';

const SignIn = observer(() => {
    let navigate = useNavigate();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const store = useStore();
    const [Username, setUsername] = useState('');
    const [Password, setPassword] = useState('');
    const [Error, setError] = useState('');
    const [UsernameError, setUsernameError] = useState(false);
    const [PasswordError, setPasswordError] = useState(false);

    useEffect(() => {
        store.logout();
    }, [store]);

    const loginClicked = async () => {
        resetErrors();

        if (!Username.trim()) {
            setUsernameError(true);
            setError('Username is required.');
            return;
        }

        if (!Password.trim()) {
            setPasswordError(true);
            setError('Password is required.');
            return;
        }

        store.setLoading(true);
        try {
            const login = await store.PasswordLogin(Username, Password);
            if (login) {
                if (store?.user?.role === 'Admin' || store?.user?.roles[0] ===1987 ) {
                    navigate('/AdminDashboard');
                } else {
                    navigate('/UserDashboard'); // Handle non-admin users if needed
                }
            } else {
                setError('Invalid username or password.');
            }
        } catch (error) {
            console.error('Login error:', error);
            setError('An unexpected error occurred. Please try again later.');
        } finally {
            store.setLoading(false);
        }

        forceUpdate();
    };

    const usernameChanged = (e) => {
        resetErrors();
        setUsername(e.target.value);
    };

    const passwordChanged = (e) => {
        resetErrors();
        setPassword(e.target.value);
    };

    const resetErrors = () => {
        setError('');
        setUsernameError(false);
        setPasswordError(false);
    };

    if (isMobile()) {
        return (
            <div>
                <p>Sign In Mobile</p>
            </div>
        );
    } else {
        return (
            <View className="signinView">
                <div className="signInContainer">
                    <div className="signInInfo">
                        <p className="header">Sign in</p>
                        <p className="subheader">Sign in to Credipple</p>
                        <TextInput
                            type="text"
                            label="Username"
                            variant="standard"
                            placeholder="name@company.co.za"
                            style={{ width: '70%', marginBottom: '30px' }}
                            onChange={usernameChanged}
                            value={Username}
                            error={UsernameError}
                        />
                        <TextInput
                            label="Password"
                            variant="standard"
                            placeholder="******"
                            type="password"
                            style={{ width: '70%' }}
                            onChange={passwordChanged}
                            value={Password}
                            error={PasswordError}
                        />
                        {Error && <p className="errorText">{Error}</p>}
                        <p className="forgotPasswordDesc">
                            Forgot your password?{' '}
                            <span className="forgotPasswordLink">Reset password</span>
                        </p>
                        <OutlinedButton
                            style={{ width: '70%', marginTop: '60px' }}
                            onClick={loginClicked}
                        >
                            Sign In
                        </OutlinedButton>
                    </div>
                    <div
                        className="signInImage"
                        style={{
                            background: `url(${process.env.REACT_APP_CDN_URL}/globalAssets/credippleRippleBackground.png) lightgray 50% / cover no-repeat`,
                        }}
                    >
                        <img
                            src={`${process.env.REACT_APP_CDN_URL}/globalAssets/credippleLogoFull.svg`}
                            alt="Credipple Logo"
                        />
                    </div>
                </div>
            </View>
        );
    }
})

export default SignIn;